﻿import _wa_datatables_ from "./webapp.datatables";
import _wa_toast_ from "./webapp.toast";

var _wa_equipment_ = {

}

$("#wa-main-content-container").on('init.dt', "#wa-equipment-search-result-container", function (e) {
    var $table = $(e.target);
    var $dataTable = $table.DataTable();


    var deleteButtonOptions = {
        url: $('#wa-equipment-delete-dialog-url').attr('href'),
        loaderTargetSelector: 'div.wa-equipment-page',
        idColumnSelector: 'equipmentId:name',
        contentInstruction: { replaceInnerFor: '#wa-equipment-search-result-container' },
        readonly: $('#wa-has-manage-equipment-authorization').length === 0
    };

    var editButtonOptions = {
        url: $('#wa-equipment-editor-dialog-url').attr('href'),
        loaderTargetSelector: 'div.wa-equipment-page',
        idColumnSelector: 'equipmentId:name',
        contentInstruction: { replaceInnerFor: '#wa-equipment-search-result-container' },
        readonly: $('#wa-has-manage-equipment-authorization').length === 0
    };
    _wa_datatables_.addEditButton($table, $dataTable, editButtonOptions);
    //TODO FIX CORRECT OPTIONS
    _wa_datatables_.addDeleteButton($table, $dataTable, deleteButtonOptions);

    /*
    var refreshButtonOptions = {
        idColumnSelector: 'workorderId:name',
        tableContainerSelector: '#wa-workorder-assign-search-result-container',
        refreshActionUrl: $('#wa-search-assign-workorder-url').attr('href'),
        loaderTargetSelector: 'div.wa-workorder-assign-page'
    };

    _wa_datatables_.addRefreshButton($table, $dataTable, refreshButtonOptions);
    */
});
$(document).on('click', 'button.wa-perform-delete-equipment-button', function (event) {
    var $form = $(event.currentTarget).closest('form.wa-delete-equipment-form');
    var data = $form.serializeArray();

    var $deleteEquiupmentDataTable = $form.find('#wa-equipment-search-result-table').DataTable();
    var selectedEquipmentIds = $deleteEquiupmentDataTable.column('equipmentId:name').data().toArray();

    selectedEquipmentIds.forEach(function (equipmentId, i) {
        data.push({ name: "selectedIds[" + i + "]", value: equipmentId })
    });

    var options = {
        url: $form.attr('action'),
        data: $.param(data),
        loaderTarget: $('div.wa-content-page'), // TODO Find the closest dialog instead
        loaderMessage: "Tar bort utrustning...",
        afterSuccess: function () {
            $form.closest('.ui-dialog-content').dialog('close');
        }
    };
    $.fn.postAjax(options);



});